import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output, } from '@angular/core'
import { ICON_TYPE } from '@spartacus/storefront'
import {
  ViewMultiValueDialogService
} from '../../../product/components/product-line/services/view-multi-value-dialog.service'
import { MbProductService } from '../../../shared/services/mb-product-service'
import { Observable, of } from 'rxjs'
import { MbOrderSimulateService } from '../../services/mb-order-simulate.service'
import { DataAnalyticsClickSource, maxQuantityFallback, MbConstants } from 'src/app/mb/shared/mb-constants'
import { CartCheckoutService } from '../../services/mb-cart-checkout.service'
import { Router } from '@angular/router'
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms'
import { CartItemComponent, CartItemContextSource } from '@spartacus/cart/base/components'
import { OrderEntry } from '@spartacus/cart/base/root'
import { Config } from '@spartacus/core'

@Component({
  selector: 'mb-cart-item',
  templateUrl: './mb-cart-item.component.html',
  styleUrls: ['./mb-cart-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MbCartItemComponent extends CartItemComponent implements OnInit {

  @Input() item: OrderEntry = {}

  @Input() isDisplayedInCartPage = true

  @Input() showYourPrice = false

  @Input() showAddToCartButton = false

  @Input() dataAnalyticsClickSource: DataAnalyticsClickSource | undefined

  iconTypes = ICON_TYPE

  entry$: Observable<OrderEntry | undefined> | undefined

  @Output() removeEntry = new EventEmitter<OrderEntry>()

  addToCartForm = new UntypedFormGroup({
    quantity: new UntypedFormControl(1, { updateOn: 'blur' }),
  })

  maxItemQuantity = +(this.config.context?.maxAllowedQuantityPerProductInCart || maxQuantityFallback)

  constructor (protected mbProductService: MbProductService,
               cartItemContextSource: CartItemContextSource,
               private viewMultiValueDialogService: ViewMultiValueDialogService,
               private orderSimulateService: MbOrderSimulateService,
               private cartCheckoutService: CartCheckoutService,
               private router: Router,
               protected config: Config) {
    super(cartItemContextSource)
  }

  ngOnInit () {
    if (this.item && !this.isDisplayedInCartPage) {
      if (this.router.url?.includes(MbConstants.MY_ACCOUNT_ORDER_PAGE)) {
        this.entry$ = of(this.item)
      } else if (!this.router.url?.includes(MbConstants.CHECKOUT_REVIEW_PAGE)) {
        this.entry$ = this.cartCheckoutService.getOrderPrice(this.item)
      } else {
        this.entry$ = this.orderSimulateService.getErpPrice(this.item)
      }
    }
  }

  removeItem (item?: OrderEntry) {
    this.removeEntry.emit(item)
  }

  openMultiValueModal (multiValueData: any, modalTitle: string) {
    this.viewMultiValueDialogService.open(multiValueData, modalTitle)
  }

  getItemsLabel () {
    return this.quantityControl?.value > 1 && 'mbcommon.items' || 'mbcommon.item'
  }

  addDataSheetUserManualLink (linkText: string, type: string, isCartPage: boolean) {
    return this.mbProductService.addDataSheetUserManualLink(linkText, type, isCartPage)
  }
}
